import Dashboard from './dashboard'
import { useAppSelector } from '../../../hooks'
import './styles.scss'
import useIsMobile from '../../../authenticated/hooks/useIsMobile'
import { useContext, useEffect } from 'react'
import { BreakpointContext } from '../../../context'
import PageLoader from '../../../authenticated/components/layout/PageLoader'
import { surveyResponsesCollection } from '@/reducers/surveyResponses'
import SurveyObserver from '@/app/components/SurveyObserver'
import { updateRouteOnMobile } from '@/utils/messageUtils'
import useMultiProgramFlowControl from '@/hooks/useMultiProgramFlowControl'
import { SurveyType } from '@/types'

function useMobileSpecificStyles() {
  const isMobile = useIsMobile()
  const breakpoint = useContext(BreakpointContext)
  // Add mobile-specific styles
  useEffect(() => {
    const root = document.querySelector('#root')

    if (isMobile && !root?.classList.contains('mobile'))
      return root?.classList.add('mobile')

    root?.classList.remove('mobile')
  }, [isMobile || breakpoint.mdAndDown])
}

const observedSurveyTypes = [
  'Onboarding',
  'TeslaFleetAuth',
  'HeardFrom',
] as SurveyType[]

export default function App() {
  const { clearFlow } = useMultiProgramFlowControl()
  useMobileSpecificStyles()

  const onboardingSurveyLoading = useAppSelector((state) => {
    const fetchQueryStates =
      surveyResponsesCollection.selectors.queryState.select(state, {
        method: 'GET',
      })
    return fetchQueryStates.every(
      (queryState) =>
        queryState.status === 'loading' || queryState.status === 'idle',
    )
  })

  // prevents screen flicker when switching to survey
  const surveyPending = useAppSelector((state) => {
    const allResponses = surveyResponsesCollection.selectors.selectAll(state)
    const surveyResponses = allResponses.filter((res) =>
      observedSurveyTypes.includes(res.survey.type),
    )
    return surveyResponses.some((res) => res?.pending_response)
  })

  useEffect(() => {
    // needed for android since route events don't always get triggered correctly
    updateRouteOnMobile('/app')
    // Force-clear multi-program onboarding flows
    clearFlow()
  }, [])

  if (onboardingSurveyLoading) {
    return <PageLoader />
  }

  return (
    <>
      <SurveyObserver observedSurveys={observedSurveyTypes} />
      {!surveyPending && <Dashboard />}
    </>
  )
}
